import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=00e0eccd&scoped=true&"
import script from "./ArticlesList.vue?vue&type=script&lang=js&"
export * from "./ArticlesList.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=00e0eccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0eccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e0eccd')) {
      api.createRecord('00e0eccd', component.options)
    } else {
      api.reload('00e0eccd', component.options)
    }
    module.hot.accept("./ArticlesList.vue?vue&type=template&id=00e0eccd&scoped=true&", function () {
      api.rerender('00e0eccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/articles/ArticlesList.vue"
export default component.exports